(function () {
  function bumpCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('cart-icon-bump');
    // Force un reflow pour pouvoir rejouer l'animation si deux ajouts
    // au panier se suivent rapidement.
    void icon.offsetWidth;
    icon.classList.add('cart-icon-bump');
  }

  function init() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, bumpCartIcon);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
